import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from '../context/ThemeContext.ts';

/**
 * Read the current theme preference + resolved theme + setter.
 * Must be called below a `<ThemeProvider>`.
 */
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme() called outside <ThemeProvider>. Mount ThemeProvider near the root.');
  }
  return ctx;
}
